var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Archivox_cities, _Archivox_countries, _Archivox_departments, _Archivox_profiles, _Archivox_roles, _Archivox_sections, _Archivox_series, _Archivox_subseries, _Archivox_trdVersions, _Archivox_users;
import { ReadonlyCollection } from "@ioip/core/lib/types";
import { City } from "./City";
import { Country } from "./Country";
import { Department } from "./Department";
import { Profile } from "./Profile";
import { JSRole } from "./JSRole";
import { Section } from "./Section";
import { Serie } from "./Serie";
import { Subserie } from "./Subserie";
import { TrdVersion } from "./TrdVersion";
import { User } from "./User";
export class Archivox {
    constructor(props) {
        _Archivox_cities.set(this, new ReadonlyCollection([]));
        _Archivox_countries.set(this, new ReadonlyCollection([]));
        _Archivox_departments.set(this, new ReadonlyCollection([]));
        _Archivox_profiles.set(this, new ReadonlyCollection([]));
        _Archivox_roles.set(this, new ReadonlyCollection([]));
        _Archivox_sections.set(this, new ReadonlyCollection([]));
        _Archivox_series.set(this, new ReadonlyCollection([]));
        _Archivox_subseries.set(this, new ReadonlyCollection([]));
        _Archivox_trdVersions.set(this, new ReadonlyCollection([]));
        _Archivox_users.set(this, new ReadonlyCollection([]));
        __classPrivateFieldSet(this, _Archivox_cities, new ReadonlyCollection((props.cities || []).map(x => new City({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_countries, new ReadonlyCollection((props.countries || []).map(x => new Country({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_departments, new ReadonlyCollection((props.departments || []).map(x => new Department({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_profiles, new ReadonlyCollection((props.profiles || []).map(x => new Profile({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_roles, new ReadonlyCollection((props.roles || []).map(x => new JSRole({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_sections, new ReadonlyCollection((props.sections || []).map(x => new Section({ sdk: this, schema: x }))), "f");
        __classPrivateFieldSet(this, _Archivox_series, new ReadonlyCollection((props.series || []).map(x => new Serie({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_subseries, new ReadonlyCollection((props.subseries || []).map(x => new Subserie({ sdk: this, schema: x }))), "f");
        __classPrivateFieldSet(this, _Archivox_trdVersions, new ReadonlyCollection((props.trdVersions || []).map(x => new TrdVersion({ schema: x, sdk: this }))), "f");
        __classPrivateFieldSet(this, _Archivox_users, new ReadonlyCollection((props.users || []).map(x => new User({ sdk: this, schema: x }))), "f");
    }
    get Version() { return "2.0.0"; }
    get Series() {
        return __classPrivateFieldGet(this, _Archivox_series, "f");
    }
    get Subseries() {
        return __classPrivateFieldGet(this, _Archivox_subseries, "f");
    }
    get TrdVersions() {
        return __classPrivateFieldGet(this, _Archivox_trdVersions, "f");
    }
    get currentTrdVersion() {
        const result = this.TrdVersions.firstOrDefault(x => x.Enabled);
        if (result == null)
            console.log('No se ha encontrado una versión de TRD activa', this.TrdVersions);
        return result;
    }
    get Sections() {
        return __classPrivateFieldGet(this, _Archivox_sections, "f");
    }
    get Users() {
        return __classPrivateFieldGet(this, _Archivox_users, "f");
    }
    get Countries() {
        return __classPrivateFieldGet(this, _Archivox_countries, "f");
    }
    get Departments() {
        return __classPrivateFieldGet(this, _Archivox_departments, "f");
    }
    get Cities() {
        return __classPrivateFieldGet(this, _Archivox_cities, "f");
    }
    get Profiles() {
        return __classPrivateFieldGet(this, _Archivox_profiles, "f");
    }
    get Roles() {
        return __classPrivateFieldGet(this, _Archivox_roles, "f");
    }
}
_Archivox_cities = new WeakMap(), _Archivox_countries = new WeakMap(), _Archivox_departments = new WeakMap(), _Archivox_profiles = new WeakMap(), _Archivox_roles = new WeakMap(), _Archivox_sections = new WeakMap(), _Archivox_series = new WeakMap(), _Archivox_subseries = new WeakMap(), _Archivox_trdVersions = new WeakMap(), _Archivox_users = new WeakMap();
